import React, { useState, useRef, useEffect } from 'react';
import { BlogVideoContent } from '@/types/blog.types';
import { strapiImage } from '@/utils/commons.utils';

interface BlogVideoProps {
    videoContent: BlogVideoContent;
    autoLoop?: boolean;
}

const BlogVideo = ({ videoContent, autoLoop = false }: BlogVideoProps) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [hasStartedPlaying, setHasStartedPlaying] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    const handlePlayClick = () => {
        setHasStartedPlaying(true);
    };

    useEffect(() => {
        if (hasStartedPlaying && videoRef.current) {
            const playPromise = videoRef.current.play();
            if (playPromise !== undefined) {
                playPromise.catch((err) => {
                    console.warn('Autoplay blocked or failed', err);
                });
            }
        }
    }, [hasStartedPlaying]);

    const handleVideoEnd = () => {
        setIsPlaying(false);
    };

    const handleVideoPause = () => {
        setIsPlaying(false);
    };
    const shouldShowVideo = !videoContent.coverImage || hasStartedPlaying;

    return (
        <div className="blog-video relative rounded-[20px] overflow-hidden my-6 max-w-full">
            {!hasStartedPlaying && videoContent.coverImage && (
                <div className="video-cover-container relative w-full">
                    <img
                        src={strapiImage(videoContent.coverImage.url)}
                        alt="Video thumbnail"
                        className="w-full h-auto rounded-[20px] object-cover"
                    />
                    <div className="absolute inset-0 flex items-center justify-center">
                        <button
                            onClick={handlePlayClick}
                            className="flex items-center justify-center w-14 h-14 bg-[#D5FF02] rounded-full cursor-pointer hover:bg-opacity-90 transition-all hover:scale-105"
                            aria-label="Play video"
                        >
                            <span className="text-black text-3xl leading-none">►</span>
                        </button>
                    </div>
                </div>
            )}

            {shouldShowVideo && (
                <video
                    ref={videoRef}
                    className="w-full rounded-[20px]"
                    controls
                    muted={!videoContent.coverImage}
                    autoPlay={!videoContent.coverImage}
                    loop={!!autoLoop}
                    onEnded={handleVideoEnd}
                >
                    <source src={strapiImage(videoContent.video.url)} type={videoContent.video.mime} />
                    Your browser does not support the video tag.
                </video>
            )}
        </div>
    );
};

export default BlogVideo;
